import { createContext, useContext } from 'react';

const PreloadContext = createContext(null);
export default PreloadContext;

export const usePreloader = (resolve) => {
	const preloadContext = useContext(PreloadContext);

	if (!preloadContext) return null;
	if (preloadContext.done) return null;
	// 데이터는 collecting=true 인 "수집 패스" 1회에서만 호출한다.
	//
	// server.render.js의 runPreloadPasses는 lazy 경계를 풀기 위해 renderToStaticMarkup을
	// 여러 번(최대 MAX_PRELOAD_PASS=8) 반복 렌더한다(warmUpLazy). usePreloader는 렌더될 때마다
	// 실행되므로, 이 가드가 없으면 lazy가 다 풀린 뒤부터 매 패스마다 동일 API가 push되어
	// 한 SSR 요청에서 같은 API가 최대 8번 호출된다(백엔드 부하 + SSR 지연).
	//
	// 따라서 collecting=false 인 워밍업 패스(1·3단계)에서는 호출하지 않고 비워두며,
	// collecting=true 인 데이터 수집 패스(2단계) 1회 렌더에서만 호출 → API 정확히 1번.
	if (!preloadContext.collecting) return null;

	preloadContext.promises.push(Promise.resolve(resolve()));
	return null;
};
